import { List, Map } from 'immutable'

import config from '../../../../../../config'

import { BUTTONSARRAY_KEY } from './constants'

const MODULE_KEY = config.modules.report.key

export const reportTypeBlocksSelector = (state, reportType) => {
    // new selected report type blocks
    const reportBlocks = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'reports', reportType, 'blocks'],
        Map()
    )
    const reportBlocksNames = reportBlocks
        .filter((block) => !block.get('isDisabled'))
        .keySeq()
        .toList()

    // blocks from data
    const buttons = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', BUTTONSARRAY_KEY, 'data'], Map())
    const buttonsNames = buttons.keySeq().toList()

    // merge all blocks from data and new report type (Immutable hasn't union for Lists)
    const allBlocks = reportBlocksNames.toSet().union(buttonsNames.toSet()).toList()

    const buttonsToToggle = allBlocks.filter((block) => {
        // if button isn't active AND is in new report type => toggle
        if (reportBlocksNames.includes(block) && !buttons.get(block)) return true
        // if button is active AND isn't in new report type => toggle
        if (!reportBlocksNames.includes(block) && buttons.get(block)) return true
        return false
    })

    return buttonsToToggle
}

export const reportTypeToSelectSelector = (state, reportId) => {
    const reportType = state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', reportId, 'reportType'], null)
    const currentReportType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'reports', 'active'], null)

    return reportType !== currentReportType ? reportType : null
}

export const blocksToToggleByActiveReport = (state, reportId) => {
    const report = state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', reportId], null)
    if (!report) return List()

    const reportBlocks = report.get('blocks', Map())
    const buttons = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', BUTTONSARRAY_KEY, 'data'])

    const buttonsToToggle = buttons.reduce((acc, isActive, block) => {
        const isInReportBlocks = reportBlocks.getIn([block, 'active'], false)

        // toggle button if is active AND isn't in report blocks OR isn't active AND is in report blocks
        if ((isActive && !isInReportBlocks) || (!isActive && isInReportBlocks)) return acc.push(block)
        // else let same state
        return acc
    }, List())

    return buttonsToToggle
}

export const getActiveReportId = (state) => {
    const tab =
        state.getIn(['ui', 'tabs', 'tabs'], List()).find((t) => t.get('type') === MODULE_KEY && t.get('active')) || null

    return (tab && tab.get('id')) || null
}

export const getActiveReportBlocksForDelete = (state, reportId) => {
    const blocks = state.getIn(['ui', 'workspace', MODULE_KEY, reportId, 'blocks'], Map())

    return blocks
        .filter((block) => block.get('level'))
        .keySeq()
        .toList()
}

export const getActiveReportBlocks = (state) => {
    const reportType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'reports', 'active'])

    return state.getIn(['authorization', 'accessRights', MODULE_KEY, 'custom', 'reports', reportType, 'blocks'], Map())
}
